<!--
 * @Description: 
 * @Date: 2022-02-17 15:53:17
 * @LastEditors: jml
-->
<template>
  <div class="container">
    <div class="container-center">
      <div class="container-center-top">
        <div v-if="needTop">
          <div class="container-center-top-title">登录</div>
          <img :src="channelData.bgUrl" />
          <div
            class="container-center-top-title"
            style="margin-bottom: 5px"
          >欢迎您，来到{{ channelData.channelName }}</div>
        </div>
        <slot name="center"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    needTop: {
      type: Boolean,
      default: true
    },
    channelData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
@screen-md-min: 600px;
@font-s: 24px;
@font-f: PingFangSC-Medium, PingFang SC;
.container {
  background-image: url('../../assets/背景.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: auto;

  &-center {
    text-align: center;
    width: 510px;
    height: auto;
    min-height: 637px;
    background: #ffffff;
    border-radius: 11px;
    margin: auto;
    padding-bottom: 45px;
    &-top {
      margin-top: 20px;
      img {
        width: 76px;
        height: 76px;
        border-radius: 50%;
        display: inline-block;
      }
      &-title {
        margin: 20px 0 20px 0;
        font-size: @font-s;
        font-family: @font-f;
        font-weight: 600;
        color: #333333;
        line-height: 40px;
      }
    }
  }
}
@media (min-width: @screen-md-min) {
  .container {
    background-image: url('../../assets/背景.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
}
</style>
